import React, { useEffect } from "react";
import {
  Button,
  Table,
  Space,
  Modal
} from "antd";
import { FileSearchOutlined, PlaySquareOutlined } from "@ant-design/icons";

//mobx
import { useStore } from "@/store";
import { observer } from "mobx-react-lite";
import { toJS, runInAction, set } from "mobx";
//mobx'

import DhspInput from './DhspInput'
import DhspInput2 from './DhspInput2'

const Dhsp = () => {
  //mobx
  const { DhspStore } = useStore()

  //获得table数据
  useEffect(() => {
    DhspStore.getDataList();
    // eslint-disable-next-line
  }, []);

  //分页控制
  const onPageChange = (page, pageSize) => {
    runInAction(() => {
      set(DhspStore, { page: page, pagesize: pageSize })
    })
    DhspStore.getDataList()
  }
  //分页控制

  //关闭X按钮
  const handleRevise = () => {
    runInAction(() => {
      set(DhspStore, { isActive: false });
    });
  };
  //新增账户
  const getAddButton = (data,title) => {
    runInAction(() => {
      set(DhspStore, { valueData: toJS(data), isActive: true,title});
    });
    if(title==='查看'){
      DhspStore.getCheckVideo()
    }else if(title==='视频回放'){
      DhspStore.getPlayBack()
    }
    
  };


  //table 列表
  const columns = [
    {
      title: "视频编号",
      dataIndex: "cameraIndexCode",
      key: 'cameraIndexCode'
    },
    {
      title: "视频名称",
      dataIndex: "cameraName",
      key: 'cameraName'
    },
    {
      title: "视频类型",
      dataIndex: "cameraTypeName",
      key: 'cameraTypeName'
    },
    {
      title: "创建时间",
      dataIndex: "createTime",
      key: 'createTime'
    },
    {
      title: "更新时间",
      dataIndex: "updateTime",
      key: 'updateTime'
    },
    {
      title: "操作",
      render: (item) => (
        <Space size="middle">
          <Button
            type="primary"
            icon={<FileSearchOutlined />}
            style={{ background: '#40ad63' }}
            onClick={() => getAddButton(item,'查看')}
          >查看</Button>
          {/* <Button
            type="primary"
            icon={<PlaySquareOutlined />}
            onClick={() => getAddButton(item,'视频回放')}
            >视频回放</Button> */}
        </Space>
      ),
    },
  ];

  return (
    <>
   
      <div className="TableInput">
        <div className="buttonBox">
        </div>
        <div className="total">共有数据:{DhspStore.total}条</div>
      </div>

      <div className="contextNr">
        <Table
          rowKey={(record) => record.cameraIndexCode}
          columns={columns}
          dataSource={DhspStore.dataList}
          className="table-box"
          pagination={{
            position: ["bottomCenter"],
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ['10', '20', '30'],
            pageSize: DhspStore.pagesize,
            current: DhspStore.page,
            total: DhspStore.total,
            onChange: (page, pageSize) => onPageChange(page, pageSize),
          }}
        />
      </div>
      <Modal
        title={DhspStore.valueData.cameraName}
        key={new Date()}
        width="1000px"
        open={DhspStore.isActive}
        footer={null}
        onCancel={handleRevise}
      >
      {
         DhspStore.title==='查看'? <DhspInput />:<DhspInput2 />
      }
      </Modal>
    </>
  );
};

export default observer(Dhsp);
